import { SxProps, Theme } from '@mui/material';
import { t } from 'i18next';

import { spacing } from '~theme/AppTheme';

type LoadsTabLoadsTableColumn = {
  key: string;
  size: string;
  sx?: SxProps<Theme>;
  title?: string;
};

export const columns: LoadsTabLoadsTableColumn[] = [
  {
    key: 'datetime',
    title: t('loads.table_headers.datetime'),
    size: '0.75fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'created',
    title: t('loads.table_headers.created'),
    size: '0.75fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'status',
    title: t('loads.table_headers.status'),
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'preview',
    title: t('loads.table_headers.preview'),
    size: '2fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'driver_and_truck',
    title: t('loads.table_headers.driver_and_truck'),
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'quantity_and_material',
    title: t('loads.table_headers.quantity_and_material'),
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'phase',
    title: t('approvals.files.loads_table.headers.phase'),
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'waypoints',
    title: t('loads.table_headers.waypoints'),
    size: '2fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'approvals',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'actions',
    size: `calc(54px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden' },
  },
];

export const gridTemplateColumns = columns.map((column) => column.size).join(' ');
